import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { SUCCESS_STORIES } from "./successStoriesData";
import SuccessStoryCard from "./SuccessStoryCard";
import SuccessStorySingle from "./SuccessStorySingle";

/**
 * /success-stories — listing page
 *
 * Follows the client mockup exactly:
 *  • Page title (minimal, top of page)
 *  • Stacked full-width story cards  (logo left / description right)
 *  • CONTACT US gradient button centered at the bottom
 */
const SuccessStories: React.FC = () => {
  return (
    <div className="bg-black min-h-screen">
      <Helmet>
        <title>Success Stories | Revolv Space</title>
        <meta
          name="description"
          content="Flight-proven power generation systems trusted on missions from Space Situational Awareness to UV Astronomy."
        />
      </Helmet>

      {/* ── Stacked cards — match mockup directly ── */}
      <div className="flex flex-col pt-24 gap-3">
        {SUCCESS_STORIES.map((story) => (
          <SuccessStorySingle key={story.story_id} story={story} />
        ))}
      </div>

      {/* ── CONTACT US — centered, gradient button, same as other pages ── */}
      <div className="flex items-center justify-center py-16 md:py-20">
        <Link to="/contact">
          <button
            className="rounded-full h-12 text-white px-10 font-bold uppercase text-sm tracking-widest transform transition-transform duration-200 hover:scale-110"
            style={{
              background: "linear-gradient(90deg, #00858F 0%, #E6007E 100%)",
            }}
          >
            CONTACT US
          </button>
        </Link>
      </div>
    </div>
  );
};

export default SuccessStories;
